/* Solas Coffee Roasters — signup popup logic.
   Config comes from data-* attributes on #solas-pop-root (see the
   solas-signup-popup snippet). Loaded as a real file, no inline script.
   Steps: 1 email → 2 preferences → 3 code → 4 attribution.
   window.SolasPopup = { init, open, close, reset } */
(function () {
  var KEY = "solas_popup_v1";
  var API = { revision: "2024-10-15" };

  var root, cfg, answers = {}, email = "", source = "", lastFocus = null, timer = null;
  var converted = false, started = false;

  var QUESTIONS = [
    { key: "brew_method",      label: "How do you brew at home?",           options: ["Filter / pour-over", "Espresso", "Cafetière", "Moka pot", "AeroPress"] },
    { key: "roast_preference", label: "What sounds like you?",              options: ["Comforting & classic", "A bit adventurous", "Bright & experimental"] },
    { key: "consumption_rate", label: "How fast do you get through a bag?", options: ["Under a week", "1–2 weeks", "A month or so"] }
  ];
  var SOURCES = ["Search", "Social media", "Saw an advert", "In a café", "Word of mouth", "Market or event"];
  var TIER_COPY = {
    "Comforting & classic":  "Start in Foundations — approachable coffees, roasted for milk or black.",
    "A bit adventurous":     "You’ll like Adventurous — brighter, fruitier lots a step beyond the everyday.",
    "Bright & experimental": "Explore is yours — rare lots and experimental processes, in limited runs."
  };
  var DEFAULT_HINT = "We’ll send the code to this address. Unsubscribe any time.";

  function el(id) { return document.getElementById(id); }

  function setHint(text, bad) {
    var h = el("solas-pop-hint");
    if (!h) return;
    h.textContent = text;
    if (bad) h.setAttribute("data-bad", "1"); else h.removeAttribute("data-bad");
  }

  function remember(days) {
    if (cfg.demo) return;
    try { localStorage.setItem(KEY, JSON.stringify({ until: Date.now() + days * 864e5 })); } catch (e) {}
  }
  function suppressed() {
    try {
      var prev = JSON.parse(localStorage.getItem(KEY) || "null");
      return !!(prev && prev.until && Date.now() < prev.until);
    } catch (e) { return false; }
  }

  function step(n) {
    root.querySelectorAll("[data-solas-step]").forEach(function (s) {
      s.classList.toggle("solas-pop-hide", s.getAttribute("data-solas-step") !== String(n));
    });
    var card = el("solas-pop-card");
    if (card) card.scrollTop = 0;
  }

  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.setAttribute("data-open", "1");
    root.setAttribute("aria-hidden", "false");
    var f = el("solas-pop-email");
    if (f && window.matchMedia("(min-width: 761px)").matches) setTimeout(function () { f.focus(); }, 340);
  }

  function close() {
    if (!root) return;
    root.setAttribute("data-open", "0");
    root.setAttribute("aria-hidden", "true");
    remember(converted ? 365 : cfg.suppressDays);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* --- Klaviyo client-side API ------------------------------------------ */
  function kFetch(path, body) {
    if (cfg.demo) return Promise.resolve({ demo: true });
    if (!cfg.companyId || !cfg.listId) {
      return Promise.reject(new Error(
        "Klaviyo not configured: set solas_company_id and solas_list_id in the " +
        "solas-signup-popup snippet. No signup was recorded."
      ));
    }
    return fetch("https://a.klaviyo.com/client/" + path + "/?company_id=" + encodeURIComponent(cfg.companyId), {
      method: "POST",
      headers: { "content-type": "application/json", revision: API.revision },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.ok) return res;
      // fetch() resolves on 4xx/5xx — treat those as the failures they are.
      return res.text()["catch"](function () { return ""; }).then(function (text) {
        var err = new Error("Klaviyo " + path + " failed: " + res.status + " " + res.statusText + " " + text);
        err.status = res.status;
        throw err;
      });
    });
  }
  function subscribe(addr) {
    return kFetch("subscriptions", {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Website popup",
          profile: { data: { type: "profile", attributes: { email: addr, properties: { signup_source: "Website popup" } } } }
        },
        relationships: { list: { data: { type: "list", id: cfg.listId } } }
      }
    });
  }
  function saveProps(addr, props) {
    return kFetch("profiles", { data: { type: "profile", attributes: { email: addr, properties: props } } });
  }
  /* --------------------------------------------------------------------- */

  function buildQuestions() {
    var wrap = el("solas-pop-questions");
    if (!wrap || wrap.childNodes.length) return;
    QUESTIONS.forEach(function (q) {
      var block = document.createElement("div");
      block.style.paddingTop = "22px";
      var label = document.createElement("p");
      label.className = "solas-pop-qlabel";
      label.style.margin = "0";
      label.textContent = q.label;
      var chips = document.createElement("div");
      chips.className = "solas-pop-chips";
      q.options.forEach(function (opt) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "solas-pop-chip";
        b.setAttribute("aria-pressed", "false");
        b.textContent = opt;
        b.addEventListener("click", function () {
          answers[q.key] = opt;
          chips.querySelectorAll(".solas-pop-chip").forEach(function (o) { o.setAttribute("aria-pressed", String(o === b)); });
          el("solas-pop-count").textContent = Object.keys(answers).length + " / " + QUESTIONS.length;
        });
        chips.appendChild(b);
      });
      block.appendChild(label);
      block.appendChild(chips);
      wrap.appendChild(block);
    });
  }

  /* Step 4 — attribution. One tap, saved to the Klaviyo profile as found_us. */
  function buildSources() {
    var wrap = el("solas-pop-sources");
    if (!wrap || wrap.childNodes.length) return;
    var chips = document.createElement("div");
    chips.className = "solas-pop-chips";
    SOURCES.forEach(function (opt) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "solas-pop-chip";
      b.setAttribute("aria-pressed", "false");
      b.textContent = opt;
      b.addEventListener("click", function () {
        if (source) return;
        source = opt;
        chips.querySelectorAll(".solas-pop-chip").forEach(function (o) {
          o.setAttribute("aria-pressed", String(o === b));
          if (o !== b) o.disabled = true;
        });
        var note = el("solas-pop-source-note");
        if (note) note.textContent = "Thanks — that genuinely helps us.";
        saveProps(email, { found_us: opt })["catch"](function (err) { console.error("[solas popup]", err); });
        setTimeout(close, 950);
      });
      chips.appendChild(b);
    });
    wrap.appendChild(chips);
  }

  function finish() {
    el("solas-pop-rec").textContent = TIER_COPY[answers.roast_preference] ||
      "We’ve sent the code to your inbox too, along with the filter recipe we use at the bench.";
    if (Object.keys(answers).length) {
      saveProps(email, answers)["catch"](function (err) { console.error("[solas popup]", err); });
    }
    step(3);
  }

  function onSubmit(e) {
    e.preventDefault();
    var input = el("solas-pop-email");
    var btn = el("solas-pop-submit");
    var val = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
      setHint("That email doesn’t look right — mind checking it?", true);
      input.focus();
      return;
    }
    email = val;
    setHint("Sending…", false);
    btn.disabled = true;
    btn.textContent = "Sending…";
    subscribe(email).then(function () {
      converted = true;
      remember(365);
      btn.disabled = false;
      btn.textContent = "Get my code";
      setHint(DEFAULT_HINT, false);
      step(2);
    })["catch"](function (err) {
      console.error("[solas popup]", err);
      btn.disabled = false;
      btn.textContent = "Try again";
      setHint("Something went wrong on our end — give it another go, or email us at hello@solascoffeeroasters.com and we’ll sort you out.", true);
    });
  }

  function readCfg() {
    var d = root.dataset;
    var company = (d.companyId || "").trim();
    var list = (d.listId || "").trim();
    var placeholder = /^YOUR|^$/;
    return {
      companyId: placeholder.test(company) ? "" : company,
      listId: placeholder.test(list) ? "" : list,
      code: d.code || "WELCOME10",
      delayMs: parseInt(d.delay || "5000", 10),
      suppressDays: parseInt(d.suppressDays || "30", 10),
      photo: d.photo && d.photo.indexOf("YOUR") === -1 ? d.photo : "",
      demo: d.demo === "1"
    };
  }

  function init() {
    root = el("solas-pop-root");
    if (!root || started) return;
    started = true;
    cfg = readCfg();

    if (!cfg.demo && (!cfg.companyId || !cfg.listId)) {
      console.error("[solas popup] Klaviyo public key and/or list id missing — the popup will not arm.");
    }

    if (cfg.photo) el("solas-pop-photo").style.backgroundImage = "url('" + cfg.photo + "')";
    el("solas-pop-codeval").textContent = cfg.code;
    buildQuestions();
    buildSources();
    step(1);

    el("solas-pop-form").addEventListener("submit", onSubmit);
    el("solas-pop-save").addEventListener("click", finish);
    el("solas-pop-skip").addEventListener("click", finish);
    var next = el("solas-pop-next");
    if (next) next.addEventListener("click", function () { step(4); });
    root.querySelectorAll("[data-solas-close]").forEach(function (n) { n.addEventListener("click", close); });
    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape" && root.getAttribute("data-open") === "1") close();
    });

    var canRecord = cfg.demo || (cfg.companyId && cfg.listId);
    var onQuietPage = !/\/(checkout|challenge|orders)/.test(location.pathname);
    if (canRecord && onQuietPage && !suppressed()) {
      clearTimeout(timer);
      timer = setTimeout(open, cfg.delayMs);
    }
  }

  function reset() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    answers = {}; email = ""; source = ""; converted = false;
    var c = el("solas-pop-count");
    if (c) c.textContent = "0 / " + QUESTIONS.length;
    root.querySelectorAll(".solas-pop-chip").forEach(function (b) {
      b.setAttribute("aria-pressed", "false");
      b.disabled = false;
    });
    var note = el("solas-pop-source-note");
    if (note) note.textContent = "";
    var f = el("solas-pop-email");
    if (f) f.value = "";
    var b = el("solas-pop-submit");
    if (b) { b.disabled = false; b.textContent = "Get my code"; }
    setHint(DEFAULT_HINT, false);
    step(1);
  }

  window.SolasPopup = { init: init, open: open, close: close, reset: reset };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
